const atualizar_retrato_matriculas_com_situacao_do_aluno = [
  {
    path: "/atualizar-retrato-matriculas-com-situacao-do-aluno",
    name: "atualizar_retrato_matriculas_com_situacao_do_aluno",
    meta: {
      breadCrumb: "Censo Escolar - Retrato para o Censo",
      allowedPermissions: ["retrato_matricula_atualizar"],
    },
    component: () =>
      import(
        "@/views/AtualizarRetratoMatriculasComSituacaoDoAluno/AtualizarRetratoMatriculasComSituacaoDoAluno.vue"
      ),
  },
];

export { atualizar_retrato_matriculas_com_situacao_do_aluno };
